import { createPhaseActions, phaseAction } from 'src/helpers/redux'
import * as settingsServiceTypes from 'src/services/storage/settings/types'

export const PREFIX = `storage/settings`

export const PREFIX_SAGA = `${PREFIX}/sagas`

export const actions = createPhaseActions(PREFIX_SAGA, {
  getSettings: phaseAction<settingsServiceTypes.IGetSettingsParams>(),
  patchSettings: phaseAction<settingsServiceTypes.IPatchSettingsParams>(),
})

export type Actions = typeof actions
